<template>
  <v-main>
    <b-modal id="showInvalidCellsModal" ref="showInvalidCellsModal" v-model="showInvalidCellsModal" title size="sm"
      hide-footer centered content-class="shadow" header-class=" pb-8 ribbon ribbon-clip ribbon-left" body-class="pt-3">
      <template #modal-title>
        <div class="ribbon-target" style="top: 10px">
          <span class="ribbon-inner bg-warning"></span>
          <span class="font-weight-bolder font-size-lg">Invalid Cells</span>
        </div>
      </template>

      <p v-for="ics in invalidCells" class="font-weight-bolder font-size-sm">
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">bay: {{ ics.bay }}</span>
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">row: {{ ics.row }}</span>
        <span class="pl-2 font-weight-bold font-size-sm" style="color: #5a5959">tier: {{ ics.tier }}</span>
      </p>

    </b-modal>
    <BlockUI v-if="isLoading" :message="loadingMessage">
      <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
    </BlockUI>
    <v-container>
      <button type="button" @click="Save_Click"
        class="btn btn-outline-primary font-weight-bold float-right mb-2  Mybtn1-primary Mybtn-size1">
        <i class="fas fa-save"></i>
        <span class="hideButtonTitle">Save</span>
      </button>
      <table-component @rowSelected="handelSelected" :headers="headers" :data="getvoyageContainersList.details">
        <template #fullEmptyStatus="{ entity }">
          {{ entity.fullEmptyStatus == null ? "-" : (entity.fullEmptyStatus ? "Full" : "Empty") }}
        </template>
        <template #oog="{ entity }">
          {{ entity.oog == null ? "-" : (entity.oog ? "Yes" : "No") }}
        </template>
        <template #containerType="{ entity }">
          {{ entity.containerType == null ? "-" : entity.containerType }}
        </template>
        <template #imdg="{ entity }">
          {{ entity.imdg == null ? "-" : (entity.imdg ? "Yes" : "No") }}
        </template>
        <template #voyageOperationType="{ entity }">
          {{ getvoyageOperationType(entity.voyageOperationType) }}
        </template>
        <template #weightLevel="{ entity }">
          {{ entity.weightLevel == null ? "-" : entity.weightLevel }}
        </template>
        <template #CLL-Yard="{ entity }">
          {{ entity.containerQuantity - entity.containerInYardQuantity }}
        </template>
        <template #CLL-Sl="{ entity }">
          {{ entity.containerQuantity - entity.stowageInstructionQuantity }}
        </template>
        <template #Color="{ entity }">
          <span :style="{ background: entity.color?.startsWith('#') ? entity.color : `#${entity.color}` }" class="tag"
            @click="togglePicker(entity.stowageInstructionDetailId)"></span>
          <sketch-picker :palette="getColorList" v-if="selectedRow === entity.stowageInstructionDetailId"
            v-model="entity.color" @input="updateColor($event, entity)" />
        </template>
        <template #Actions="{ entity }">
          {{ "-" }}
        </template>
        <template #footer-WL="{ data }">
          Total
        </template>
        <template #footer-CLL="{ data }">
          {{
            data.reduce((sum, el) => sum += el.containerQuantity, 0)
          }}
        </template>
        <template #footer-Yard="{ data }">
          {{
            data.reduce((sum, el) => sum += el.containerInYardQuantity, 0)
          }}
        </template>
        <template #footer-SL="{ data }">
          {{
            data.reduce((sum, el) => sum += el.stowageInstructionQuantity, 0)
          }}
        </template>
        <template #footer-CLL-Yard="{ data }">
          {{data.reduce((sum, el) => sum += el.containerQuantity, 0) - data.reduce((sum, el) => sum +=
            el.containerInYardQuantity, 0)}}
        </template>
        <template #footer-CLL-Sl="{ data }">
          {{data.reduce((sum, el) => sum += el.containerQuantity, 0) - data.reduce((sum, el) => sum +=
            el.stowageInstructionQuantity, 0)}}
        </template>
        <template #invalidCellQuantity="{ entity }">
          <div>
            <span @click="showInvalidCells(entity.invalidCells)" v-if="entity.invalidCellQuantity"
              class="btn btn-label-danger border-radius">NotOK</span>
            <span v-else class="btn  btn-sm btn-label-success border-radius">OK</span>
          </div>
        </template>

      </table-component>
      <v-row>
        <v-col v-if="selectedView === 1 /* StowagInstructionView.SingleBay */">
          <single-bay-view></single-bay-view>
        </v-col>
        <v-col v-else-if="selectedView === 2 /* StowagInstructionView.MiniOneBayWide */">
          <one-bay-wide></one-bay-wide>
        </v-col>
        <v-col v-else-if="selectedView === 3 /* StowagInstructionView.mini */">
          <all-bays></all-bays>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script ts>
import ContainerTypeBadge from "@/view/pages/stowageinstruction/components/ContainerTypeBadge.vue"
import AllBays from '@/view/pages/stowageinstruction/components/AllBaysView/AllBays.vue'
import OneBayWide from '@/view/pages/stowageinstruction/components/OneBayWideView/OneBayWide.vue'
import ContainerDetailsModal from '@/view/pages/stowageinstruction/components/ContainerDetailsModal'
import SingleBayView from "@/view/pages/stowageinstruction/components/SingleBayView/SingleBayView.vue"
import { mapGetters, mapActions, Store } from "vuex"
import { StowagInstructionView, VesselBay, StowagInstructionDeck, StowagInstructionType } from "@/core/services/store/stowagInstruction.types"
import TableComponent from '@/components/table.vue'
import ApiService from "@/core/services/api.service"
import { Twitter } from 'vue-color';
import { Compact } from 'vue-color';
import { Slider } from 'vue-color';

export default {
  inject: ["showErrors", "showSuccess", "isStandalone"],

  components: {
    ContainerTypeBadge,
    AllBays,
    SingleBayView,
    OneBayWide,
    ContainerDetailsModal,
    TableComponent,
    'sketch-picker': Compact,
  },
  data() {
    return {
      showInvalidCellsModal: false,
      invalidCells: [],
      GroupFilter: {},
      headers: [
        { field: 'voyageOperationType', header: 'Operation Type' },
        { field: 'portOfDischargeName', header: 'POD' },
        { field: 'transitDestinationName', header: 'POT' },
        { field: 'containerSize', header: 'Size' },
        { field: 'containerType', header: 'Type' },
        { field: 'fullEmptyStatus', header: 'F-M' },
        { field: 'oog', header: 'OOG' },
        { field: 'imdg', header: 'IMDG' },
        { field: 'imodgClassNumber', header: 'DG Class' },
        { field: 'weightLevel', header: 'WL' },
        { field: 'containerQuantity', header: 'CLL' },
        { field: 'containerInYardQuantity', header: 'Yard' },
        { field: 'stowageInstructionQuantity', header: 'SL' },
        { field: 'CLL-Yard', header: 'CLL-Yard' },
        { field: 'CLL-Sl', header: 'CLL-Sl' },
        { field: 'invalidCellQuantity', header: 'valid' },
        { field: 'Color', header: 'Color' },
        { field: '', header: 'Actions' },
      ],
      singleBayViewKey: 'o',
      // selectedView: getSelectedView,
      // TODO: get from enum
      viewOptions: [
        {
          display: "Single Bay",
          value: StowagInstructionView.SingleBay
        },
        {
          display: "Mini - One bay wide",
          value: StowagInstructionView.MiniOneBayWide
        },
        {
          display: "Mini - All bays",
          value: StowagInstructionView.MiniAllBays
        }
      ],
      deckOptions: [
        {
          display: "Above",
          value: StowagInstructionDeck.Above
        },
        {
          display: "Below",
          value: StowagInstructionDeck.Below
        },
        {
          display: "Both",
          value: StowagInstructionDeck.Both
        }
      ]
    }
  },
  methods: {
    getvoyageOperationType(type) {
      let voyageOperationType = '';
      switch (type) {
        case type = 1:
          voyageOperationType = "Discharge"
          break
        case type = 2:
          voyageOperationType = "Load"
          break
        case type = 3:
          voyageOperationType = "Restow"
          break
        case type = 4:
          voyageOperationType = "Inventory"
          break
        case type = 6:
          voyageOperationType = "HandleROB"
          break
        default:
          voyageOperationType = ''
      }
      return voyageOperationType
    },
    togglePicker(rowId) {
      // Toggle the color picker for the clicked row only
      this.selectedRow = this.selectedRow === rowId ? null : rowId;
    },
    updateColor(color, entity) {
      this.getStowagInstructionResponse.data.vesselHatches.forEach(vhs => {
        vhs.vesselBays.forEach(vbs => {
          vbs.onDeck.cells.forEach(cell => {
            if (cell.stowageInstructionDetailId == entity.stowageInstructionDetailId) {
              cell.color = color.hex
            }
          })

          vbs.hold.cells.forEach(cell => {
            if (cell.stowageInstructionDetailId == entity.stowageInstructionDetailId) {
              cell.color = color.hex
            }
          })
        })
      })

      entity.color = color.hex
      this.setCurrentColor(color)

      this.selectedRow = this.selectedRow === entity.stowageInstructionDetailId ? null : entity.stowageInstructionDetailId;
      /*  this.vesselMonitoringData?.vesselHatches[0].vesselBay.onDeck.cells.forEach(c => {
         c.color = color.hex.substring(1)
       }) */
    },
    showInvalidCells(invalidCells) {
      this.invalidCells = []
      this.showInvalidCellsModal = true
      this.invalidCells = invalidCells
    },
    Save_Click() {
      const voyageId = this.$route.params.id

      var stowageInstructionFilterGroup = {
        voyageId: voyageId,
        portId: this.$route.query.PortId,
        pod: this.$route.query.POD == "True" ? true : false,
        pot: this.$route.query.POT == "True" ? true : false,
        size: this.$route.query.Size == "True" ? true : false,
        type: this.$route.query.Type == "True" ? true : false,
        FM: this.$route.query.FM == "True" ? true : false,
        OOG: this.$route.query.OOG == "True" ? true : false,
        iMDG: this.$route.query.IMDG == "True" ? true : false,
        WL: this.$route.query.WL == "True" ? true : false,
        HandleRestow: this.$route.query.HandleRestow == "True" ? true : false,
        DGClass: this.$route.query.DGClass == "True" ? true : false,
        OperationType: this.$route.query.OperationType == "True" ? true : false,
        HandleROB: this.$route.query.HandleROB == "True" ? true : false,
      }

      var stowageInstructionDetails = this.getvoyageContainersList.details

      var stowageInstructionDetailCells = []

      this.getStowagInstructionResponse.data.vesselHatches.forEach(vhs => {
        vhs.vesselBays.forEach(vbs => {
          vbs.onDeck.cells.forEach(cell => {
            if (cell.stowageInstructionDetailId > 0) {
              stowageInstructionDetailCells.push(
                {
                  "stowageInstructionDetailId": cell.stowageInstructionDetailId,
                  "color": cell.color.substring(1),
                  "vesselBayType": cell.vesselBayType,
                  "bayId": cell.bayId,
                  "row": cell.row,
                  "tier": cell.tier
                }
              )
            }
          })

          vbs.hold.cells.forEach(cell => {
            if (cell.stowageInstructionDetailId > 0) {
              stowageInstructionDetailCells.push(
                {
                  "stowageInstructionDetailId": cell.stowageInstructionDetailId,
                  "color": cell.color.substring(1),
                  "vesselBayType": cell.vesselBayType,
                  "bayId": cell.bayId,
                  "row": cell.row,
                  "tier": cell.tier
                }
              )
            }
          })
        })
      })
      var result = { StowageInstructionFilterGroup: stowageInstructionFilterGroup, StowageInstructionDetails: stowageInstructionDetails, StowageInstructionDetailCells: stowageInstructionDetailCells }

      this.$store.commit("isStowagInstructionLoadingMutation", true);

      ApiService.post(
        "system/stowageinstruction/addnew",
        result
      )
        .then((response) => {

        })
        .finally(() => {
          var postMessageParams = {
            action: "StowageInstrucationSaved"
          }

          window.parent.postMessage(postMessageParams, "*");
          this.$store.commit("isStowagInstructionLoadingMutation", false);
        });



    },
    handelSelected(stowageInstruction) {
      //this.toggleisHighlightCells(stowageInstruction)
      var voyageContainersList = this.getvoyageContainersList.details.map(v => {
        if (v.stowageInstructionDetailId == stowageInstruction.stowageInstructionDetailId) {
          return { ...v, isSelected: true }
        }
        return {
          ...v,
          isSelected: false
        }
      })
      this.$store.commit('VoyageContainersdetailsList', voyageContainersList)
      this.setCurrentColor(stowageInstruction.color.substring(1))
      this.setCurrentStowagSelected(stowageInstruction)
    },
    selectNextItem() {
      let currentIndex = this.bayOptionsItems.findIndex(item => item.value === this.selectedBay)
      if (currentIndex >= 0 && currentIndex < this.bayOptionsItems.length - 1) {
        this.selectedBay = this.bayOptionsItems[currentIndex + 1].value
      } else {
        this.selectedBay = this.bayOptionsItems[0].value // Wrap around to the first item
      }
    },
    selectPreviousItem() {
      let currentIndex = this.bayOptionsItems.findIndex(item => item.value === this.selectedBay)
      if (currentIndex > 0) {
        this.selectedBay = this.bayOptionsItems[currentIndex - 1].value
      } else {
        this.selectedBay = this.bayOptionsItems[this.bayOptionsItems.length - 1].value // Wrap around to the last item
      }
    },
    ...mapActions(["setCurrentStowagSelected", "fetchvoyagecontainerslist", "setCurrentColor", "fetchStowagInstruction2DBayView", "setPropertiesFromQueryString", "fetchStowagInstructionColorByList", "fetchStowagInstructionBayList", "setSelectedDeck", "setSelectedBay", "setSelectedView", "setSelectedColorBy"]),

  },
  computed: {
    ...mapGetters(['getVesselMonitoringData', 'getStowageErrors', 'getvoyageContainersList', 'getStowagInstructionResponse', 'getcurrentColorSlected', 'getIsStowagInstructionContainerDetailModalOpen', 'getStowagInstructionContainerDetailResponse', "getStowagInstructionColorByList", "getIsStowagInstructionLoading", "setIsStowagInstructionLoading", "getStowagInstructionColorPalettes", "getStowagInstructionSelectedDeck", "getStowagInstructionSelectedBay", "getStowagInstructionSelectedView", "getStowagInstructionSelectedColorBy", "getStowagInstructionBayList", "getStowagInstructionColorByList", "getStowagInstructionLoadingMessage", "setLoadingMessage"]),
    IsStowagInstructionContainerDetailModalOpen: {
      get() {
        return this.getIsStowagInstructionContainerDetailModalOpen
      }/* ,
      set(value) {
        this.setIsStowagInstructionContainerDetailModalOpen(value)
      } */
    },
    vesselMonitoringData() {
      return this.getVesselMonitoringData
    },
    isLoading: {
      get() {
        return this.getIsStowagInstructionLoading.length > 0 ? true : false
      },
      set(value) {
        this.setIsStowagInstructionLoading(value)
      }
    },
    selectedView: {
      get() {
        // return selected view, if not selected
        return this.getSelectedView || 3

      },
      set(value) {
        this.setSelectedView(value)
      }
    },
    loadingMessage: {
      get() {
        return this.getLoadingMessage
      },
      set(value) {
        this.setLoadingMessage
      }
    },
    selectedColorBy: {
      get() {
        return this.getStowagInstructionSelectedColorBy
      },
      set(value) {
        this.setSelectedColorBy(value)
      }
    },
    colorPalettes() {
      let updatedColorCodes = getvoyageContainersList.colorList.map(code => {
        return code.startsWith('#') ? code : `#${code}`;
      });
      return updatedColorCodes;
    },
    bayOptions() {
      return this.getBayList
    },
    colorByOptions() {
      return this.getColorByList
    },
    selectedBay: {
      get() {
        return this.getSelectedBay
      },
      set(value) {
        this.setSelectedBay(value)
      }
    },
    selectedDeck: {
      get() {
        return this.getSelectedDeck
      },
      set(value) {
        this.setSelectedDeck(value)
      }
    },
    isSingleBay() {
      return this.selectedView === "Single Bay"
    },
    viewOptionsItems() {
      return this.viewOptions.map(e => {
        return {
          display: e.display,
          value: e.value
        }
      })
    },
    deckOptionsItems() {
      return this.deckOptions.map(e => {
        return {
          display: e.display,
          value: e.value
        }
      })
    },
    bayOptionsItems() {
      return this.bayOptions.map(e => {
        return {
          display: e.bayNo,
          value: e.bay
        }
      })
    },
    colorByOptionsItems() {
      return this.colorByOptions.map(e => {
        return {
          display: e.name,
          value: e.id
        }
      })
    },
    isOneBayWide() {
      return this.selectedView === "Mini - One bay wide"
    },
    isAllBays() {
      return this.selectedview === "mini - all bays"
    },
    isDeckSelectDisabled() {
      return !(this.selectedView === StowagInstructionView.SingleBay)
    },
    isBaySelectDisabled() {
      return !(this.selectedView === StowagInstructionView.SingleBay)
    }
  },
  mounted() {
  },
  created() {
    // Get the ID from the route
    const voyageId = this.$route.params.id
    // Get other parameters from the route
    const GroupFilter = {
      voyageId: voyageId,
      portId: this.$route.query.PortId,
      pod: this.$route.query.POD == "True" ? true : false,
      pot: this.$route.query.POT == "True" ? true : false,
      size: this.$route.query.Size == "True" ? true : false,
      type: this.$route.query.Type == "True" ? true : false,
      FM: this.$route.query.FM == "True" ? true : false,
      OOG: this.$route.query.OOG == "True" ? true : false,
      iMDG: this.$route.query.IMDG == "True" ? true : false,
      WL: this.$route.query.WL == "True" ? true : false,
      FileId: this.$route.query.FileId,
      HandleRestow: this.$route.query.HandleRestow == "True" ? true : false,
      DGClass: this.$route.query.DGClass == "True" ? true : false,
      OperationType: this.$route.query.OperationType == "True" ? true : false,
      HandleROB: this.$route.query.HandleROB == "True" ? true : false
    }

    // Update the Vuex store
    this.$store.commit('setVesselIdMutation', Number(voyageId))

    // update request data
    this.setPropertiesFromQueryString({ operationStatus: 1, operationType: 1 })

    // page api request
    ApiService.setHeader();
    //this.fetchStowagInstruction2DBayView()
    //this.fetchvoyagecontainerslist(GroupFilter)
    this.$store.dispatch("fetchvoyagecontainerslist", GroupFilter).then(() => {
      //this.loading = false;
      const errors = this.getStowageErrors;
      this.showErrors(errors);

    });
  },
}
</script>

<style scoped>
.tag {
  display: inline-block;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
  width: 58px;
  height: 24px;
  border: 1px solid #e4e6ef;
}

.container-type-legend {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}

.container-type-legend v-badge {
  margin-right: 10px;
}

.container-icons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.container-icons v-icon {
  font-size: 18px;
  margin-right: 10px;
}

.container-type-legend v-badge[color="red"]::before {
  background-color: red;
}

.container-type-legend v-badge[color="grey"]::before {
  background-color: grey;
}

.container-type-legend v-badge[color="blue"]::before {
  background-color: blue;
}

.select-row {
  background-color: #009999;
  border-radius: 4px;
}

.arrow-button {
  color: white;
  fill: white;
  background-color: transparent;
  border: none;
}

.select-box {
  flex-grow: 1;
  margin: 0 8px;
  background-color: transparent;
  color: white;
  background-color: #fff;
  border-color: #009999;
}

.v-select__selections {
  color: white;
}

.btn.btn-label-success {
  background-color: rgba(29, 201, 183, 0.1);
  color: #1dc9b7;
  cursor: text !important;
}

.btn.btn-label-danger {
  background-color: rgba(253, 39, 235, 0.1);
  color: #af45a4;
  cursor: cursor !important;
}
</style>
